import { PipesModule } from './../pipes/pipes.module';
import { ButtonModule, ButtonsModule, DropDownButtonModule } from '@progress/kendo-angular-buttons';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { LabelModule } from '@progress/kendo-angular-label';
import { PopupModule } from '@progress/kendo-angular-popup';
import { TaskAddComponent } from './task-add.component';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { UploadModule } from '@progress/kendo-angular-upload';

@NgModule({
    imports: [
        CommonModule,
        DialogsModule,
        PopupModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        InputsModule,
        LabelModule,
        DateInputsModule,
        ButtonModule,
        ButtonsModule,
        DropDownButtonModule,
        DropDownsModule,
        PipesModule,
        UploadModule,
    ],
    declarations: [
        TaskAddComponent,
    ],
    exports: [
        TaskAddComponent,
    ]
})
export class TaskAddModule { }
